import { render } from "./GoToPaymentButtonComponent.vue?vue&type=template&id=39e431ee"
import script from "./GoToPaymentButtonComponent.vue?vue&type=script&lang=js"
export * from "./GoToPaymentButtonComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__